import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIcon from '../../../elements/oe-icon';
import OEColor from '../../../color-picker/oe-color';
import {OEMediaCenterCategoryFlags} from '../oe-media-center-model';

export default class OEMediaCenterCategoryController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            categories: [],
            actualCategory: -1
        };

        this.onActualMediaCenterCategoryChanged = this.onActualMediaCenterCategoryChanged.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterCategoryChanged, this.onActualMediaCenterCategoryChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterCategoryChanged, this.onActualMediaCenterCategoryChanged);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({categories: [], actualCategory: -1});
            return;
        }

        let mediaCenter = this.oe.sharedInterface.getUIControllerMediaCenter();

        this.setState({categories: mediaCenter.getCategories(), actualCategory: mediaCenter.getActualCategory()});
    }

    onActualMediaCenterCategoryChanged(message, userInfo)    {
        this.setState({actualCategory: userInfo.category});
    }

    renderCategories()  {
        let disabled = !this.props.enabled;

        let categories = [];
        for(let i = 0; i < this.state.categories.length; ++i)   {
            const index = i; // do not remove this otherwise parameter index in onClick refers to some reference to i, yielding index === this.state.categories.length
            const category = this.state.categories[index];
            if(category.mask == 0 || (category.flags & OEMediaCenterCategoryFlags.hideInMediaCenter)) continue;

            categories.push(<div
                key={index}
                className={'extra-light-hover-bg media-center-category-item ' + (index === this.state.actualCategory ? ' selected' : '') + (disabled ? ' disabled' : '')}
                onClick={disabled ? () => {}: () => this.onClick(index)}
            >
                <OEIcon
                    style={{color: OEColor.toDOMStr(category.icon.color)}}
                    code={category.icon.code}
                />
            </div>);
        }

        if(this.props.hideIfNotNeeded && (categories.length === 0 || (categories.length === 1 && this.state.actualCategory >= 0)))  return null;

        return (
            <div 
                className={this.props.className + ' media-center-category-collection'} 
                style={this.props.style}
            >
                {categories}
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                {this.renderCategories()}
            </React.Fragment>
        );
    }

    onClick(index)   {
        this.oe.sharedInterface.getUIControllerMediaCenter().setActualCategory(index);
    }
}

OEMediaCenterCategoryController.defaultProps = {
    className: '',
    moduleId: '',
    enabled: true,
    hideIfNotNeeded: false
};

OEMediaCenterCategoryController.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    moduleId: PropTypes.string,
    enabled: PropTypes.bool,
    hideIfNotNeeded: PropTypes.bool
};